import type { SorterResult } from "antd/es/table/interface";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { DisplayAdvertiserPublisherParams } from "../../hooks/useDisplayAdvertiserPublisherDataAndParams";
import type { ISortProps } from "../../utils/utils";

interface ICreateHandleSortParams {
    isCompareMode: boolean;
    params: DisplayAdvertiserPublisherParams;
    setSingleSort?: (sort: ISortProps) => void;
}

export const createHandleSort = <T extends Record<string, unknown> = Record<string, unknown>>({
    isCompareMode,
    params,
    setSingleSort,
}: ICreateHandleSortParams): ((shouldUpdateUrl: boolean) => (sorter: SorterResult<T>) => void) => {
    return (shouldUpdateUrl) => (sorter) => {
        if (isCompareMode) {
            proNavigator.updateQueryParams(
                {
                    ...params,
                    asc: sorter.order === "ascend",
                },
                { reload: false },
            );
        } else {
            if (shouldUpdateUrl) {
                proNavigator.updateQueryParams(
                    {
                        ...params,
                        sort: sorter.columnKey,
                        asc: sorter.order === "ascend",
                    },
                    { reload: false },
                );
            }
            if (setSingleSort) {
                setSingleSort({
                    sort: sorter.columnKey as string,
                    asc: sorter.order === "ascend",
                });
            }
        }
    };
};
